module.exports = __webpack_public_path__ + "static/media/options-cercle.34cdcde9.png";